import { Add, Edit } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography/Typography";
import moment from "moment";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector, useStore } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { getMachinePoolsofUser } from "../../../../actions/machines";
import {
  DeleteNotification,
  ShareNotification,
  UpdateNotification,
  getAttachments,
} from "../../../../actions/notification";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import { Theme247 } from "../../../../styles/Theme247";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import NotificationAttachments from "../../NotificationAttachments";
import InnerDetails from "../InnerDetails/InnerDetails";
import { ReactComponent as EditSVG } from "../../../../assets/edit.svg";

import { ReactComponent as SaftyInfo } from "../../../../assets/SafetyInfo.svg";

import { ReactComponent as EventSVG } from "../../../../assets/Event.svg";
import AddIcon from "@mui/icons-material/Add";
import { getNotificationTypee } from "../../../../types";
import Costs from "../Cost/costs";
import { setItem } from "../../../../utils/DataProtection";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const styles = {
  snackbarStyleViaContentProps: {
    backgroundColor: "orange",
  },
  snackbarStyleViaNestedContent: {
    backgroundColor: "lightgreen",
    color: "black",
  },
};

export default connect(
  ({ data, notification, isadmin, userProfile, profile }) => ({
    data,
    notification,
    isadmin,
    userProfile,
    profile,
  }),
  {
    getAttachments,
    getMachinePoolsofUser,
    UpdateNotification,
    DeleteNotification,
    ShareNotification,
  }
)((props) => {
  const i18n = useStore().getState().i18n;
  const store = useStore().getState();
  const [notificationState, setNotificationState] = useState(false);

  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedKey, setExpandedKey] = useState(false);

  const [accordianArray, setAccordianArray] = useState([]);

  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  var notification = props.notification;
  var userProfile = props.userProfile;

  const handleChange = (expanded, key) => {
    setIsExpanded(expanded);
    setExpandedKey(key);
    let array = accordianArray;
    if (array[key]) {
      array[key].expanded = expanded;
    } else {
      array.push({ key: key, expanded: expanded });
    }
    setAccordianArray(array);
  };

  useEffect(() => {
    // set notification state for select
    setNotificationState(notification.notification?.status);
    setItem(
      "chatroomnodeid",
      notification?.notification?.haschatroom?.[0].chatroom?.nodeid
    );
  }, [notification]);

  const isequipmentof =
    notification?.notification?.isnotificationof &&
    notification?.notification?.isnotificationof[0]?.equipment?.isequipmentof[0]
      ?.equipmentpool != undefined
      ? notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.equipmentpool?.name
      : notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.area.name.de;

  const equp_local =
    notification?.notification?.isnotificationof &&
    notification?.notification?.isnotificationof[0]?.equipment;
  const equq_pool_local =
    notification?.notification?.isnotificationof &&
    notification?.notification?.isnotificationof[0]?.equipment?.isequipmentof[0]
      ?.equipmentpool != undefined
      ? notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.equipmentpool
      : notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.area;

  const getDateFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())
    );
  };
  const getTimeFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getHours() +
      ":" +
      (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
    );
  };
  var ids = [];

  if (notification?.notification?.hasattachment !== undefined) {
    notification.notification.hasattachment.map((i, k) => {
      var id = i?.attachment?.file?.fileid;
      ids.push(id);
    });
  }
  const creation_date = getDateFromTimestamp(
    notification?.notification?.created
  );
  const creation_time = getTimeFromTimestamp(
    notification?.notification?.created
  );

  const date_today = getDateFromTimestamp(moment(Date.now()));
  const time_today = getTimeFromTimestamp(moment(Date.now()));

  var executed_date = "";
  var executed_time = "";
  if (notification?.notification?.hasreport != undefined) {
    executed_date = getDateFromTimestamp(
      moment(notification.notification.hasreport[0].report.executed)
    );
    executed_time = getTimeFromTimestamp(
      moment(notification.notification.hasreport[0].report.executed)
    );
  }
  //props.getAttachments({"fileids": ids}, 'NI')

  function getDateTimeFromTimestamp(unixTimeStamp) {
    let date = new Date(unixTimeStamp);
    return (
      ("0" + date.getDate()).slice(-2) +
      "." +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "." +
      date.getFullYear()
    );
  }

  function getHour(unixTimeStamp) {
    let date = new Date(unixTimeStamp);
    return (
      ("0" + date.getHours()).slice(-2) +
      ":" +
      ("0" + date.getMinutes()).slice(-2)
    );
  }

  /*
   * Styles
   */
  const useStyles = makeStyles()(() => ({
    notificationDetails: {
      padding: "28px 24px",
    },
    notificationStateSelect: {
      width: "100%",
    },
    notificationDetailsContainer: {
      display: "flex",
      flexDirection: "row",
      paddingLeft: 24,
    },
    optionsButtonContainer: {
      marginTop: -12,
      marginLeft: 24,
    },
    sectionButtonFooter: {
      ...Theme247.sectionButtonFooter,
    },
    heading: {
      fontSize: Theme247.typography.pxToRem(15),
      fontWeight: Theme247.typography.fontWeightRegular,
    },
  }));
  const { classes } = useStyles();

  var state_payload = {};
  useEffect(() => {
    if (
      notification?.notification?.isnotificationof &&
      notification?.notification?.isnotificationof[0]?.equipment
        .isequipmentof[0]?.equipmentpool != undefined
    ) {
      state_payload = {
        nodeid:
          notification?.notification?.isnotificationof[0]?.equipment.nodeid,
        pool:
          notification?.notification?.isnotificationof[0]?.equipment
            ?.isequipmentof[0]?.equipmentpool.name,
        poolnodeid:
          notification?.notification?.isnotificationof[0]?.equipment
            ?.isequipmentof[0]?.equipmentpool.nodeid,
        equipment: notification?.notification?.isnotificationof,
        from: "notification",
      };
    } else {
      if (
        notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment != undefined
      ) {
        state_payload = {
          nodeid:
            notification?.notification?.isnotificationof[0]?.equipment.nodeid,
          pool:
            notification?.notification?.isnotificationof[0]?.equipment
              .isequipmentof[0]?.area.name,
          areanodeid:
            notification?.notification?.isnotificationof[0]?.equipment
              .isequipmentof[0]?.area.nodeid,
          area:
            notification?.notification?.isnotificationof[0]?.equipment
              .isequipmentof[0],
          equipment: notification?.notification?.isnotificationof,
          from: "notification",
        };
      }
    }
  }, [notification]);

  const [navigate, setNavigate] = useState(false);

  let notiType = notification?.notification?.type;

  return (
    <div>
      {navigate ? <Navigate push to="/dashboard" /> : null}
      {notiType !== 6 && (
        <>
          <InnerDetails notification={notification} />{" "}
          <Divider orientation="horizontal" />
        </>
      )}

      <div className={_s(Theme247.sectionContentContainer)}>
        <Typography variant="h1" component="h2">
          {i18n.notification_description}{" "}
          {notiType === 6
            ? " der geplanten Wartung"
            : getNotificationTypee(notiType, store.language)}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            maxWidth: "100%",
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {notiType == 6
            ? notification?.notification?.hasworkflow &&
              notification?.notification?.hasworkflow[0]?.workflow
                ?.hasworkflowstep &&
              notification?.notification?.hasworkflow[0]?.workflow
                ?.hasworkflowstep[0]?.workflowstep.description
            : notification?.notification?.description}
        </Typography>

        {notification?.notification?.hasmaintenancetask ? (
          notification.notification.hasmaintenancetask[0].maintenancetask
            ?.safetynotice !== null ? (
            <>
              {Object.keys(
                notification.notification.hasmaintenancetask[0]?.maintenancetask
                  ?.safetynotice
              ).length ? (
                <>
                  {(notification?.notification?.hasmaintenancetask[0]
                    ?.maintenancetask?.safetynotice[store.language] || notification?.notification?.hasmaintenancetask[0]
                    ?.maintenancetask?.safetynotice) !== "" ? (
                    <div className="safty_notice">
                      <>
                        <div className="_header">
                          <div>
                            <SaftyInfo />
                          </div>
                          <div className="_text">Sicherheitshinweise</div>
                        </div>
                        <div className="_content">
                          {
                            notification?.notification?.hasmaintenancetask[0]
                              ?.maintenancetask?.safetynotice[store.language] ? notification?.notification?.hasmaintenancetask[0]
                              ?.maintenancetask?.safetynotice[store.language] :notification?.notification?.hasmaintenancetask[0]
                              ?.maintenancetask?.safetynotice || ""
                          }
                        </div>
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              <br></br>
            </>
          ) : (
            ""
          )
        ) : (
          ""
        )}
        {notification?.notification?.hasmaintenancetask ||
        notification.notification?.status === 6 ? (
          ""
        ) : (
          <Typography
            variant="body2"
            sx={{
              maxWidth: "100%",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
            }}
          >
            <div
              style={
                {
                  // textDecorationLine:
                  //   notification?.notification?.errorcode === "" ||
                  //   notification?.notification?.errorcode === null
                  //     ? "line-through"
                  //     : "",
                }
              }
            >
              <b>Fehlercode:</b>{" "}
              <span>
                {notification?.notification?.errorcode === "" ||
                notification?.notification?.errorcode === null
                  ? " --- "
                  : notification?.notification?.errorcode}
              </span>
            </div>
          </Typography>
        )}


        {notification.notification?.type == 6 ? (
          <NotificationAttachments
            edit={false}
            attachmentsOf={"maintenanceTask"}
            notification={notification}
            workflowAttachments={
              notification?.notification?.hasworkflow &&
              notification?.notification?.hasworkflow[0]?.workflow
                ?.hasworkflowstep &&
              notification?.notification?.hasworkflow[0]?.workflow
                ?.hasworkflowstep[0]?.workflowstep.hasattachment
            }
          />
        ) : (
          <NotificationAttachments
            edit={false}
            attachmentsOf={"notification"}
            notification={notification}
          />
        )}
      </div>
      {/* <div style={{ display: notification.notification.type == 6 ? 'none' : 'block' }}>
        <Typography variant="h1" component="h2" style={{ marginLeft: 22 }}>{i18n.notification_solutions}</Typography>

        {notification?.notification?.hasworkflow?.length > 0 ? notification?.notification?.hasworkflow?.map((x, k) => {
          return (

            <Accordion key={k} onChange={(e, expanded) => handleChange(expanded, k)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading} style={{ marginLeft: 7, fontSize: 18, fontWeight: accordianArray.length && accordianArray.filter(arr => { return arr.key == k })[0]?.expanded ? "bold" : "500" }}>{x?.workflow?.title != undefined ? x?.workflow?.title : i18n.no_workflow_title}</Typography>
              </AccordionSummary>
              <AccordionDetails style={{ padding: "24px" }}>
                <Typography>
                  {x?.workflow?.hasworkflowstep[0]?.workflowstep?.description}
                  <NotificationAttachments attachmentsOf={"solution"} edit={false} notification={undefined} workflowAttachments={x?.workflow?.hasworkflowstep[0]?.workflowstep?.hasattachment} />
                </Typography>


              </AccordionDetails>
              {canUserPerformAction(props.profile?.features?.["notification.workflow"], "update") && <Link to='/edit-workflow-step'
                state={{
                  workflowAttachments: x?.workflow?.hasworkflowstep[0]?.workflowstep?.hasattachment,
                  title: x?.workflow?.title,
                  description: x?.workflow?.hasworkflowstep[0]?.workflowstep?.description,
                  workflowstepnodeid: x?.workflow?.hasworkflowstep[0]?.workflowstep?.nodeid,
                  workflownodeid: x?.workflow?.nodeid,
                  pageType: 'edit',
                  from: 'notification',
                  notification: notification?.notification
                }
                }>
                <Button size="large" variant="outlined" startIcon={<Edit />} style={{ marginTop: -3, marginBottom: 21, marginLeft: 24 }} >
                  {i18n.edit}
                </Button> 

              </Link>}

            </Accordion>

          )

        }) : <Typography variant="body_2" style={{ marginLeft: 25, color: '#C9C6C5' }}>{i18n.none_solution}</Typography>}

      </div> */}
      {notification.notification?.type == 6 &&
      notification?.notification?.hasreport === undefined ? (
        <>
          <Divider orientation="horizontal" />

          <Grid item xs={12} className={classes.buttonContainer}>
            {canUserPerformAction(
              props.profile?.features?.["notification.report"],
              "create"
            ) && (
              // <Link
              // to="/create-report"
              // state={{
              //   date: date_today,
              //   time: time_today,
              //   notificationnodeid: notification.notification?.nodeid,
              //   pageType: "add",
              // }}
              // >
              <Button
                variant="contained"
                color="primary"
                startIcon={<EventSVG />}
                sx={{ margin: "20px", letterSpacing: "1.25px" }}
                onClick={() => {
                  props.setActiveTab(1);
                  props.setProtokolEditView(true);
                }}
              >
                {i18n.carry_now}
              </Button>
              // </Link>
            )}
          </Grid>

          {/* <Grid container alignItems="center" className={classes.notificationDetails}>
        <Typography variant="h1" component="h2">{i18n.maintenance_report}</Typography>


        {notification.notification.hasreport == undefined ? (
          <>
            <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
              <Typography variant="body2" >{i18n.maintenance_report_empty}</Typography>

            </Grid>

            <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
              {canUserPerformAction(props.profile?.features?.["notification.report"],"create")&&<div className={classes.itemcardButtonFooter}>
                <Link className="btn-submit" to='/create-report'
                  state={{
                    date: date_today,
                    time: time_today,
                    notificationnodeid: notification.notification.nodeid,
                    pageType: 'add'
                  }}>
                  <Button startIcon={
                    <Add />} variant="outlined">{i18n.maintenance_report_add_btn}</Button>
                </Link>
              </div>}
              
            </Grid>
          </>


        ) : ( ""
          // <>
          // <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
          //   <Typography variant="body2" >{i18n.protocol_title_pretext+' '+moment(notification.notification.hasreport[0].report.executed).format('DD.MM.YYYY') +','+moment(notification.notification.hasreport[0].report.executed).format('hh:mm')+' '+i18n.protocol_title_posttext+' '+notification.notification.hasreport[0].report.hasauthor[0].user.givenname+' '+notification.notification.hasreport[0].report.hasauthor[0].user.surname}</Typography>
          // </Grid>
          // <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
          //   <Typography variant="h6" >{i18n.protocol_description}</Typography>
          // </Grid>
          // <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
          //   <Typography variant="body2" >{notification.notification.hasreport[0].report.comment}</Typography>
          // </Grid>
          // <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
          //   <NotificationAttachments from="notification" attachmentsOf={"report"} rootNodeId={notification.notification.nodeid} edit={false} workflowAttachments={notification.notification.hasreport[0].report.hasattachment}  />
          // </Grid>

          // <Grid xs={12} className={classes.notificationDetailsContainer} style={{ paddingLeft: 0, marginTop: 25 }}>
          //   {canUserPerformAction(props.profile?.features?.["notification.report"],"update")&&<Link to='/edit-report'
          //   state={ {
          //     attachments:notification.notification.hasreport[0].report.hasattachment,
          //     reportnodeid:notification.notification.hasreport[0].report.nodeid,
          //     date: executed_date,
          //     time: executed_time,
          //     comment:notification.notification.hasreport[0].report.comment,
          //     notificationnodeid: notification.notification.nodeid,
          //     attachmentsOf:"report",
          //     pageType: 'edit'
            
          // }}>
          //   <Button size="large" variant="outlined" color='primary'>
          //     {i18n.protocol_update}
          //   </Button>

          // </Link>}
          
          // </Grid>
          // </>
        )}

      </Grid> */}
        </>
      ) : (
        <>
          <Divider orientation="horizontal" />
          {notification?.notification?.type !== 6 && (
            <div>
              <div
                className={classes.sectionButtonFooter}
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  margin: "20px",
                }}
              >
                {canUserPerformAction(
                  props.profile?.features?.notification,
                  "update"
                ) && (
                  <Link
                    to="/edit-notification"
                    state={{
                      notification: notification?.notification,
                      equip: equp_local,
                      equip_pool: equq_pool_local,
                      date: creation_date,
                      time: creation_time,
                      pageType: "edit",
                      from: "notification",
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<EditSVG />}
                      color="primary"
                      style={{ width: "107px" }}
                    >
                      {i18n.edit_notification}
                    </Button>
                  </Link>
                )}

                {/* <Button size="large" variant="contained" color="primary">
            {i18n.discuss_notification}
          </Button> */}
                <span style={{ paddingRight: 10 }}></span>
                {canUserPerformAction(
                  props.profile?.features?.["notification.workflow"],
                  "create"
                ) && (
                  <Link
                    to="/create-workflow-step"
                    state={{
                      notification: notification?.notification,
                      from: "notification",
                      pageType: "add",
                    }}
                  >
                    <Button size="large" variant="contained">
                      {i18n.add_solution}
                    </Button>
                  </Link>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <>
        {notification?.notification?.type === 6 ? <Costs fromOverview /> : ""}
      </>
    </div>
  );
});
